import Modal from "../ui/Modal";

const HistoricChangesModal = ({openModalHistory, brandName, serviceName, historicChanges, setOpenModalHistory, user}) => {
  return (
    <Modal
      activeModal={openModalHistory}
      onClose={() => setOpenModalHistory(false)}
      title="Historial de cambios"
      centered
    >
      <div className="flex flex-col gap-2">

        <div className="text-xs text-gray-800 font-semibold text-lg">
          <span className="font-bold">Cliente: </span>
          <span className="font-light">{brandName}</span>
        </div>

        <div className="text-xs text-gray-800 font-semibold text-lg">
          <span className="font-bold">Servicio: </span>
          <span className="font-light">{serviceName}</span>
        </div>

        <h3 className="text-xs font-bold text-gray-700 mt-3">Historial de cambios:</h3>
        {/* Sección de comentarios */}
        <div className="max-h-[300px] overflow-y-auto">
        {historicChanges?.map((change, index) => (
          <div
            key={index}
            className="mb-3 px-4 py-3 rounded-lg border border-gray-300 shadow-sm bg-gray-50"
          >
            {/* Header */}
            <div className="flex flex-row justify-between items-center mb-2">
              <div className="flex flex-row gap-2 items-center">
                <img
                  src={change?.worker?.foto?.url || user?.worker?.foto?.url}
                  alt={change?.worker?.name || user?.worker?.name}
                  className="w-8 h-8 rounded-full object-cover"
                />
                <span className="text-xs font-semibold text-gray-800">
                  {change?.worker?.name || "Usuario desconocido"}
                </span>
              </div>
              <div className="text-xs text-gray-500">
                {new Date(change.date).toLocaleString("es-ES", {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>

            {/* Content */}
            <div className="text-xs text-gray-700 space-y-1">
              <p className="flex items-center">
                <span className="font-medium text-gray-500">Campo actualizado: </span>
                <span className="font-bold text-gray-800 ml-1">{change.field}</span>
              </p>

              <div className="flex items-center space-x-2">
                <span className="font-medium text-gray-500">Antiguo valor:</span>
                <span className="text-red-500 italic">{change.oldValue || "N/A"}</span>
                <span className="text-gray-500">→</span>
                <span className="font-medium text-gray-500">Nuevo valor:</span>
                <span className="text-green-500 italic">{change.newValue || "N/A"}</span>
              </div>
            </div>

          </div>
        ))}

        </div>
      </div>
    </Modal>
  )
}

export default HistoricChangesModal